(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/bubble-win-message/assets/javascripts/components/bubble-win-message.js') >= 0) return;  svs.modules.push('/components/tur/bubble-win-message/assets/javascripts/components/bubble-win-message.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

setGlobal('svs.tur.bubbleWinMessage.components.BubbleWinMessage', _ref => {
  let options = _ref.options,
    children = _ref.children;
  const _options$demo = options.demo,
    demo = _options$demo === void 0 ? false : _options$demo,
    amount = options.amount,
    extraicon = options.extraicon,
    game = options.game,
    disableGrassroot = options.disableGrassroot;
  const winMessage = svs.tur.bubbleWinMessage.utils.winMessage;
  const BigHeader = svs.tur.bubbleWinMessage.components.BigHeader;
  const SmallHeader = svs.tur.bubbleWinMessage.components.SmallHeader;
  const BankAdvice = svs.tur.bubbleWinMessage.components.BankAdvice;
  const Description = svs.tur.bubbleWinMessage.components.Description;
  const WinAmount = svs.tur.bubbleWinMessage.components.WinAmount;
  const usersettings = svs.tur.usersettings;
  const _React = React,
    useState = _React.useState;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    recivers = _useState2[0],
    setRecivers = _useState2[1];
  const isWin = parseInt(amount, 10) > 0;
  const shouldFetchRecivers = !recivers && !demo && !isWin && !disableGrassroot && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const formattedAmount = svs.utils.format.Currency(options.amount);
  const Header = isWin && !demo ? BigHeader : SmallHeader;
  const _winMessage = winMessage(_objectSpread(_objectSpread({}, options), {}, {
      isWin,
      recivers
    })),
    header = _winMessage.header,
    description = _winMessage.description,
    winAmountText = _winMessage.winAmountText;
  if (shouldFetchRecivers) {
    usersettings.get({
      key: 'receivers'
    }).done(_ref2 => {
      let _ref2$value = _ref2.value,
        value = _ref2$value === void 0 ? [] : _ref2$value;
      setRecivers(value);
    });
    return null;
  }
  return React.createElement("div", {
    className: "bubble-win-container",
    "data-testid": "bubble-win-container-test-id",
    role: "alert"
  }, React.createElement("div", {
    className: "bubble-win-message ".concat((!description || description.length < 80) && 'tiny-tail'),
    "data-testid": "bubble-win-message-test-id"
  }, React.createElement(Header, {
    header: header
  }), React.createElement("div", {
    className: "bubble-win-message-wrapper"
  }, children && children, !children && !extraicon && isWin && React.createElement(WinAmount, {
    amount: formattedAmount,
    extraGameWin: game && game.extragame,
    winText: winAmountText
  }), description && React.createElement(Description, {
    description: description
  }), (amount >= 1000000 || extraicon) && React.createElement(BankAdvice, {
    extraicon: extraicon
  }))));
});

 })(window);